import React, { Component } from "react";
import InputField from "./Elements/InputField";
import SubmitFeed from "./Elements/SubmitFeed";


class FlickrFeed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hashtag: "",
            handle: "",
            error: false,
            handleError: false,
            loading: false,
        }
    }

    onTextChange = (e) => this.setState({ [e.target.name]: e.target.value, error: false, handleError:false });

    onSubmit = () => {
        const { updateStep, selectedFilterId } = this.props;
        const { hashtag,handle } = this.state;

        if (selectedFilterId == 2 && hashtag == '') {
           this.setState({ error: true });
        } else if (selectedFilterId == 1 && handle == '') {
           this.setState({ handleError: true });
        } else {

            var obj = {
                networkId: 8,
                filter: selectedFilterId,
                moderation: 0,
                feedText: '',
                accountId: 0,
            }
            if(selectedFilterId == 2){
                obj['feedText'] = hashtag.split('#').join('');
            }else if(selectedFilterId == 1){
                obj['feedText'] = handle.split('@').join('');
            }

            this.setState({ error: false, handleError:false, loading: true });

            updateStep(2, obj, () => this.setState({ loading: false }));
        }
    }

    render() {
        const { hashtag, handle, error, handleError, loading } = this.state;
        const { selectedFilterId } = this.props;
        return (
            <div className="ob-feed-form-wrapper w-100">
                {selectedFilterId == 2 ? <div className="selectSource-right mb-3">
                    <div className="form-group position-relative advance-input custom-input">
                        <div className="position-relative d-flex">
                            <span className="hastag d-flex align-items-center">
                                <i className={`fas fa-hashtag`}></i>
                            </span>
                            <InputField name={"hashtag"} placeholder="Enter hashtag here.." className="form-control p-3" value={hashtag} onChangeHandler={(e) => this.onTextChange(e)} />
                        </div>
                        {error && <span id="feedsslackkeyworderror" className="errorMessage required text-start">This field is required</span>}
                    </div>
                </div> :
                    <div className="selectSource-right mb-2">
                        <div className="form-group position-relative advance-input custom-input">
                            <div className="position-relative d-flex">
                                <span className="hastag d-flex align-items-center">
                                    <i className={`fas fa-at`}></i>
                                </span>
                                <InputField name={"handle"} placeholder="Enter handle here.." className="form-control p-3" value={handle} onChangeHandler={(e) => this.onTextChange(e)} />
                            </div>
                        </div>
                        {handleError && <span id="feedsslackkeyworderror" className="errorMessage required text-start">This field is required</span>}
                    </div>}
                <div className="click-next d-flex align-items-center py-3 px-3 rounded justify-content-between">
                    <SubmitFeed loading={loading} onSubmit={this.onSubmit} onBack={this.props.backAction} disabled={selectedFilterId == 2 ? !hashtag.trim() : !handle.trim()} />
                </div> 
            </div>
        )
    }
}

export default FlickrFeed;